import { TokenIcon } from "@/components/token"
import { Button } from "@/components/ui/button"
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"
import { DialogClose as DialogClosePrimitive } from "@radix-ui/react-dialog"
import { FormField, FormItem, FormLabel } from "@/components/ui/form"
import { Input } from "@/components/ui/input"
import InvoicePreviewPdfModal from "./invoice-preview-pdf.modal"
import { z } from "zod"
import { invoiceSchema } from "./invoice.schema"

interface InvoiceSendModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  invoice: z.input<typeof invoiceSchema>;
}

export default function InvoiceSendModal({
  open,
  onOpenChange,
  invoice,
}: InvoiceSendModalProps) {
  const total = invoice.items.reduce(
    (acc, item) => acc + Number(item.quantity) * Number(item.unitValue),
    0,
  )
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Send Invoice</DialogTitle>
          <DialogClose />
        </DialogHeader>
        <div className="flex flex-col gap-4">
          <div className="flex flex-row justify-start items-center gap-2">
            <p className="text-sm text-gray-300">Send invoice for</p>
            <div className="border font-medium border-gray-400 rounded-md p-1 px-2 text-sm flex flex-row gap-1 items-center">
              <TokenIcon name={invoice.token} size={15} />
              <span className="pl-1">
                {total.toLocaleString("en-US", { currency: "USD" })}
              </span>
              <span>{invoice.token}</span>
            </div>
          </div>
          <p className="text-sm text-gray-300">
            Invoices can't be edited after being sent
          </p>
          <FormField
            name="sendToEmails[0]"
            defaultValue=""
            render={({ field }) => (
              <FormItem>
                <FormLabel>Cc</FormLabel>
                <Input {...field} placeholder="Add email (optional)" />
              </FormItem>
            )}
          />
        </div>
        <DialogFooter className="gap-2">
          <DialogClosePrimitive asChild>
            <Button variant="outline">Continue Editing</Button>
          </DialogClosePrimitive>
          <InvoicePreviewPdfModal invoice={invoice} />
          <Button type="submit" form="invoice">
            Send Invoice
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
